export const rotatedArray = (arr: any[], rotateCount: number = 1) => {
    return arr
        .slice(rotateCount % arr.length, arr.length)
        .concat(arr.slice(0, rotateCount % arr.length));
}
